// @flow
// Externals
import React, { useState, useMemo, useEffect } from "react";
import Lottie from "react-lottie-player";

// Styles
// $FlowFixMe
import "./index.scss";

// Animation Data
//import animationData from '../../static/lottie/Q8 - 3f fade.json';
import animationData from "../../static/lottie/Q8.json";

const NUMBER = "8";

const frames = {
	jump1Step: [
		[0, 10],
		[10, 40],
		[30, 70],
	],
	jump2Step: [
		[50, 70], // Forward from step 1 to 3
		[0, 20], // Backward from step 3 to 1
	],
};

// Question Animation
/*::
type Props = {
	value: string,
	options: string[]
}
*/
const Animation = (props /*: Props */) /*: any */ => {
	//
	const [direction /*: number | null */, setDirection] = useState(null);
	const [previousFrame /*: number */, setPreviousFrame] = useState(1);
	const [segmentFrom /*: number | null */, setSegmentFrom] = useState(null);
	const [segmentTo /*: number | null */, setSegmentTo] = useState(null);
	const [speed /*: number | null */, setSpeed] = useState(1); // Speed default is 1 - normal speed

	const frame = useMemo(() => {
		return props.options.indexOf(props.value) + 1;
	}, [props.value, props.options]);

	useEffect(() => {
		if (frame === previousFrame) {
			// do nothing
		}

		// Go to the next value
		else if (frame > previousFrame) {
			let segment = frames.jump1Step[frame - 1];
			setSpeed(1);

			// Jump over 1 step
			if (frame - previousFrame === 2) {
				segment = frames.jump2Step[0];
				// Slow down animation
				setSpeed(0.5);
			}

			setDirection(1);
			setSegmentFrom(segment[0]);
			setSegmentTo(segment[1]);

			setPreviousFrame(frame);
		} else if (frame > 0) {
			// Backward
			let segment = frames.jump1Step[frame];
			setSpeed(1);

			// Jump over 1 step
			if (previousFrame - frame === 2) {
				segment = frames.jump2Step[1];
				setSpeed(0.5);
			}

			setDirection(-1);
			setSegmentFrom(segment[1]);
			setSegmentTo(segment[0]);

			setPreviousFrame(frame);
		}
	}, [frame, previousFrame]);

	return (
		<div className="animation" data-cy={`div-animation-q${NUMBER}`}>
			{frame > 0 && segmentFrom !== null && segmentTo !== null ? (
				<Lottie
					className="lottie-container basic"
					animationData={animationData}
					play={true}
					loop={false}
					segments={[segmentFrom, segmentTo]}
					direction={direction}
					speed={speed}
				/>
			) : (
				<Lottie
					className="lottie-container basic"
					animationData={animationData}
					play={false}
					loop={false}
				/>
			)}
		</div>
	);
};

// Exports
export default Animation;
